<template>
  <v-dialog v-model="isShowDialog" persistent max-width="420">
    <v-card>
      <v-card-title class="font-weight-bold text-h4">
        <p
          v-html="inputInfo.title"
          :class="
            inputColor.titleColor
              ? `color:${inputColor.titleColor}`
              : 'color:black'
          "
        ></p>
      </v-card-title>
      <v-card-text class="text-body-1" style="font-size: 1.3rem !important;">
        <p
          v-html="inputInfo.message"
          :class="
            inputColor.titleColor
              ? `color:${inputColor.messageColor}`
              : 'color:black'
          "
        ></p>
      </v-card-text>
      <v-card-actions>
        <v-btn
          v-if="btnConfig !== 'oneBtn'"
          :disabled="isLoadingConfirmation"
          :color="
            inputColor.cancelButtonTitleColor
              ? inputColor.cancelButtonTitleColor
              : 'grey'
          "
          x-large
          text
          @click="cancel"
        >
          {{
            inputInfo.cancelButtonTitle ? inputInfo.cancelButtonTitle : "Cancel"
          }}
        </v-btn>
        <v-spacer />
        <v-progress-circular
          v-if="isLoadingConfirmation"
          indeterminate
          color="green"
          class="ml-2 mr-2"
          size="26"
          width="2"
        ></v-progress-circular>
        <v-btn
          v-if="!isLoadingConfirmation"
          class="white--text"
          :color="
            inputColor.confirmButtonTitleColor
              ? inputColor.confirmButtonTitleColor
              : 'green'
          "
          x-large
          @click="confirm"
        >
          {{
            inputInfo.confirmButtonTitle
              ? inputInfo.confirmButtonTitle
              : "Confirm"
          }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    isLoadingConfirmation: Boolean,
    isShowDialog: {
      type: Boolean,
      required: true,
      default: false,
    },
    btnConfig: String,
    inputInfo: {
      type: Object,
      default() {
        return {
          title: "Confirmation",
          message: "Are You Sure You Want To Proceed?",
          confirmButtonTitle: "Confirm",
          cancelButtonTitle: "Cancel",
        };
      },
    },
    inputColor: {
      type: Object,
      default() {
        return {
          titleColor: "black",
          messageColor: "black",
          confirmButtonTitleColor: "green",
          cancelButtonTitleColor: "grey",
        };
      },
    },
    isDefaultConfirm: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
  },
  methods: {
    confirm() {
      if (this.isDefaultConfirm) {
        this.isShowDialog = false;
        return;
      }
      this.$emit("eConfirm");
    },
    loading() {
      this.isLoadingConfirmation = true;
    },
    stopLoading() {
      this.isLoadingConfirmation = false;
    },
    cancel() {
      this.$emit("eCancel");
    },
  },
};
</script>
